module.exports = __webpack_public_path__ + "img/content_right1.0f4f13aa.png";